import React, { useEffect } from "react";
import ReactGA from "react-ga";

function DataProtection() {
  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "auto" });
    ReactGA.pageview(window.location.pathname + window.location.search);
  });

  return (
    <>
      <div>
        Lorem ipsum dolor sit amet consectetur adipisicing elit. Earum maxime
        perspiciatis quaerat dolorum rerum sunt nisi veniam, similique nemo
        eligendi eaque? Numquam cumque veritatis natus at sit ab, totam
        inventore, rerum ea repudiandae cum voluptates pariatur incidunt laborum
        expedita mollitia velit alias quidem quod consectetur blanditiis?
        Inventore, reprehenderit rem. Animi exercitationem eveniet quisquam
        assumenda aspernatur vero accusantium neque autem? Laudantium mollitia
        sequi necessitatibus eligendi dolor, iste doloremque porro expedita
        similique, vero praesentium quasi, nesciunt ipsam tenetur quas ad
        aperiam qui et! Placeat officia doloribus odit earum iusto voluptate
        aspernatur consectetur ratione dolore corporis, laudantium ab illum
        eligendi ex dolores doloremque.
      </div>
    </>
  );
}

export default DataProtection;
